import { TEMPLATE_LABELS, TEMPLATE_NAMES, isComponentTemplate } from '@game-platform/theme-constructor';
import type { TemplateName } from './useDefaultTemplate';

interface TemplateSelectorProps {
  template: TemplateName;
  onTemplateChange: (t: TemplateName) => void;
  /** The template players get when a launch names none — marked in the list. */
  defaultTemplate?: TemplateName;
}

// Matches ConstructorTopBar's unified control style (h-7, px-3, font-mono 11px).
export function TemplateSelector({
  template,
  onTemplateChange,
  defaultTemplate,
}: TemplateSelectorProps) {
  const label = (name: TemplateName) =>
    name === defaultTemplate ? `${TEMPLATE_LABELS[name]} (default)` : TEMPLATE_LABELS[name];
  return (
    <select
      value={template}
      onChange={(e) => {
        if (isComponentTemplate(e.target.value)) onTemplateChange(e.target.value);
      }}
      className="h-7 rounded border border-neutral-700 bg-neutral-900 px-3 font-mono text-[11px] text-white outline-none hover:bg-neutral-800"
    >
      {TEMPLATE_NAMES.map((name) => (
        <option key={name} value={name}>
          {label(name)}
        </option>
      ))}
    </select>
  );
}
